/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortDirection } from './sort-direction';


export interface SortExpression { 
    direction?: SortDirection;
    propertyName?: string | null;
}



